module.exports = __webpack_public_path__ + "img/collection_gem.2c2ff830.png";